import { render } from "./ReferralCountCard.vue?vue&type=template&id=77a34146&scoped=true"
import script from "./ReferralCountCard.vue?vue&type=script&lang=js"
export * from "./ReferralCountCard.vue?vue&type=script&lang=js"

import "./ReferralCountCard.vue?vue&type=style&index=0&id=77a34146&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a34146"]])

export default __exports__